import { render } from "./ThresholdMainList.vue?vue&type=template&id=4b9b9b25"
import script from "./ThresholdMainList.vue?vue&type=script&lang=js"
export * from "./ThresholdMainList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__